import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReportReducer } from '../reducers';

export const selectReportFeature = createFeatureSelector<ReportReducer.ReportState>(ReportReducer.featureName);

export const selectReport = createSelector(selectReportFeature, (state: ReportReducer.ReportState) => state.item);
